<template>
  <v-container
    fluid
    class="pa-md-12"
  >
    <v-row wrap>
      <v-col cols="12">
        <BankSwitcher />
      </v-col>
      <v-col cols="12">
        <v-card
          class="pa-5 px-md-12 py-md-6"
          min-height="700px"
        >
          <v-row wrap>
            <v-col cols="12">
              <div
                v-motion
                :initial="{ opacity: 0, x: 10 }"
                :enter="{ opacity: 1, x: 0, scale: 1 }"
                :delay="0"
                class="font-weight-bold"
              >
                Sessions
              </div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col
              v-if="
                dataStore?.sessionsDataOrdered?.length !== 0 &&
                (bankStore.currentBank === 'part-2-question-bank' ||
                bankStore.currentBank === 'part-1-question-bank' ||
                bankStore.currentBank === 'duke-elder-question-bank')
              "
              v-for="status in ['ongoing', 'completed']"
              :key="status"
              cols="12"
              v-motion
              :initial="{ opacity: 0, x: 10 }"
              :enter="{ opacity: 1, x: 0, scale: 1 }"
              :delay="0"
            >
              <div
                v-if="
                  dataStore.sessionsDataOrdered.filter(
                    (x) => x.status === status
                  ).length !== 0
                "
                class="font-weight-bold text-caption"
              >
                {{ status.charAt(0).toUpperCase() + status.slice(1) }}
              </div>
              <v-table
                v-if="
                  dataStore.sessionsDataOrdered.filter(
                    (x) => x.status === status
                  ).length !== 0
                "
                class="text-caption mt-3"
                density="compact"
                fixed-header
              >
                <thead>
                  <tr>
                    <th class="text-left">Action</th>
                    <th class="text-left">Created At</th>
                    <th class="text-left">No. Questions</th>
                    <th class="text-left">Mode</th>
                    <th class="text-left">Timer</th>
                    <th class="text-left">Progress</th>
                    <th class="text-left">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(session, idx) in filteredSessions(status)"
                    :key="session.id"
                    v-motion
                    :initial="{ opacity: 0, x: 10 }"
                    :enter="{ opacity: 1, x: 0, scale: 1 }"
                    :delay="idx * 20"
                  >
                    <td>
                      <v-btn
                        @click="goToSession(session.id)"
                        color="primary"
                        rounded="lg"
                        variant="flat"
                        size="x-small"
                      >
                        {{ status === "completed" ? "View" : "Resume" }}
                      </v-btn>
                      <v-icon
                        @click="openSessionInNewTab(session.id)"
                        class="ml-2 hidden-xs"
                        size="x-small"
                        color="progress"
                        icon="mdi-open-in-new"
                      ></v-icon>
                    </td>
                    <td>{{ easyToReadDate(session.createdAt.seconds) }}</td>
                    <td>
                      {{ session.numberOfQuestions }} Question{{
                        session.numberOfQuestions !== 1 ? "s" : ""
                      }}
                    </td>
                    <td>
                      {{ session.enableTestMode ? "Test" : "Learn" }}
                    </td>
                    <td>
                      {{
                        session.enableTimer && session.timerAmount
                          ? session.timerAmount + " mins"
                          : "N/A"
                      }}
                    </td>
                    <td v-if="session?.questions">
                      {{
                        perc(
                          session?.questions.filter(
                            (q) => q.chosenAnswerId !== null
                          ).length,
                          session?.numberOfQuestions
                        )
                      }}%
                    </td>
                    <td>
                      {{
                        session?.finalStats
                          ? perc(
                              session?.finalStats?.correct,
                              session?.numberOfQuestions
                            ) + "%"
                          : "N/A"
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>

            <v-col
              v-else-if="
                dataStore?.sessionsDataOrdered?.length !== 0 &&
                (bankStore.currentBank === 'interview-bank' ||
                  bankStore.currentBank === 'part-2-video-bank')
              "
              cols="12"
              v-motion
              :initial="{ opacity: 0, x: 10 }"
              :enter="{ opacity: 1, x: 0, scale: 1 }"
              :delay="0"
            >
              <v-table
                v-if="dataStore.sessionsDataOrdered"
                class="text-caption mt-3"
                density="compact"
                fixed-header
              >
                <thead>
                  <tr>
                    <th class="text-left">Action</th>
                    <th class="text-left">Created At</th>
                    <th class="text-left">No. Stations</th>
                    <th class="text-left">Examiner</th>
                    <th class="text-left">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(session, idx) in dataStore.sessionsDataOrdered"
                    :key="session.id"
                    v-motion
                    :initial="{ opacity: 0, x: 10 }"
                    :enter="{ opacity: 1, x: 0, scale: 1 }"
                    :delay="idx * 20"
                  >
                    <td>
                      <v-btn
                        @click="goToSession(session.id)"
                        color="primary"
                        rounded="lg"
                        variant="flat"
                        size="x-small"
                      >
                        {{ session?.completed ? "View" : "Resume" }}
                      </v-btn>
                      <v-icon
                        @click="openSessionInNewTab(session.id)"
                        class="ml-2 hidden-xs"
                        size="x-small"
                        color="progress"
                        icon="mdi-open-in-new"
                      ></v-icon>
                    </td>
                    <td>{{ easyToReadDate(session.createdAt.seconds) }}</td>
                    <td>
                      {{
                        session.stationCount ??
                        session.stationIds?.length ??
                        session.stations?.length
                      }}
                    </td>

                    <td>
                      {{
                        session.examinerEmail ? session.examinerEmail : "N/A"
                      }}
                    </td>
                    <td>
                      {{ session?.completed ? "Completed" : "In Progress" }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>

            <v-col
              v-motion
              :initial="{ opacity: 0, x: 10 }"
              :enter="{ opacity: 1, x: 0, scale: 1 }"
              :delay="100"
              v-else
              cols="12"
            >
              <div class="text-caption">No sessions yet.</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
  import { useDateHelpers } from "@/composables/dateHelpers";
  const { easyToReadDate } = useDateHelpers();
  import { useDataStore } from "@/store/data";
  const dataStore = useDataStore();
  import BankSwitcher from "@/components/BankSwitcher.vue";
  import { useBankStore } from "@/store/bank";
  const bankStore = useBankStore();
  import { useRouter } from "vue-router";
  const router = useRouter();

  const goToSession = (sessionId) => {
    const mapper = {
      "duke-elder-question-bank": "/sessions/duke-elder-question-bank/",
      "part-1-question-bank": "/sessions/part-1-question-bank/",
      "part-2-question-bank": "/sessions/",
      "part-2-video-bank": "/sessions/part-2-video-bank/",
      "interview-bank": "/sessions/interview-bank/",
    };
    router.push(mapper[bankStore.currentBank] + sessionId);
  };

  const perc = (num, total) => {
    if (total == 0 || isNaN(num) || isNaN(total)) {
      return 0;
    }
    return ((num / total) * 100).toFixed(1);
  };

  const openSessionInNewTab = (sessionId) => {
    const mapper = {
      "duke-elder-question-bank": "/sessions/duke-elder-question-bank/",
      "part-1-question-bank": "/sessions/part-1-question-bank/",
      "part-2-question-bank": "/sessions/",
      "part-2-video-bank": "/sessions/part-2-video-bank/",
      "interview-bank": "/sessions/interview-bank/",
    };

    window.open(mapper[bankStore.currentBank] + sessionId, "_blank");
  };

  const filteredSessions = (status) => {
    const filtered = dataStore.sessionsDataOrdered.filter(
      (x) => x.status === status
    );
    return filtered;
  };
</script>

<style scoped></style>
